import {
  Image
} from '@chakra-ui/react'
import LogoUrl from "@/assets/images/DucaSanGiusto_logo-marrone.webp";
export const Logo = () => {
  return (
    <Image 
      w="280px"
      src={LogoUrl}
      alt="Logo Duca San Giusto"
    />
  );
};